import React, {useEffect, useState, useCallback} from 'react';
import {useForm} from "react-hook-form";
import apiClient from "../../../../utils/apiClient";
import FormSelect from "../../../forms/form-control/FormSelect";
import FormInputDate from "../../../forms/form-control/FormInputDate";
import FormSubmitButton from "../../../forms/form-control/FormSubmitButton";
import FormSearchableSelect from "../../../forms/form-control/FormSearchableSelect";
import {updateStateValue} from "../../../../utils/stateHelpers";

/**
 * Filter component for DirectEntry Report
 * @returns {JSX.Element}
 * @constructor
 */
const FieldDailiesToHTMLFilters = (prop) => {
    const {register, handleSubmit, errors, control, setValue} = useForm();
    const {filters, setFilters} = prop;
    const [disciplines, setDisciplines] = useState([]);
    const [jobs, setJobs] = useState([]);
    const updateReportFilters = useCallback((id, value) => {
        setFilters(prevState => ({
            ...prevState,
            [id]: value
        }));
    },[setFilters]);

    // discipline selection handler
    const disciplineSelectionHandler = (e) => {
        const {id, value} = e.target;
        updateReportFilters(id, value);
        setValue('job_id', null);
        updateReportFilters('job_id', null);

        // get all jobs by Discipline Id
        apiClient
            .post('getAllActiveAndNonactiveJobsByDisciplineId', {'discipline_id': value})
            .then(response => {
                const jobItems = response.data.map(
                    ({id, job_number}) => ({value: id, label: job_number})
                );
                setJobs(jobItems);
            });
    }

    // job selection handler
    const jobSelectionHandler = (value) => {
        setValue('start_date', null);
        updateReportFilters('start_date', null);
        setValue('end_date', null);
        updateReportFilters('end_date', null);
        updateReportFilters('job_id', value);

        // get job start date and end date by job Id
        apiClient
            .post('getJobStartAndEndDatesByJobId', {'id': value})
            .then(response => {
                setValue('start_date', response.data.job_start_date);
                setValue('end_date', response.data.projected_close_date);
                updateReportFilters('start_date', response.data.job_start_date);
                updateReportFilters('end_date', response.data.projected_close_date);
            });
    }

    const onSubmit = () => {
        updateReportFilters('isLoading', true);
        updateReportFilters('isSubmitted', true);

        //get pdf export file
        apiClient('htmlExportFieldDailies', {
                method: 'POST',
                responseType: 'blob', //Force to receive data in a Blob Format
                data: filters
            })
            .then(response => {
                //Create a Blob from the HTML Document
                const file = new Blob(
                    [response.data],
                    {type: 'text/html'});
                //Build a URL from the file
                const fileURL = URL.createObjectURL(file);
                //Open the URL on new Window
                window.open(fileURL);

                // // temporary blocked functionality, don't remove
                // // to dump into pdf
                // const blob = new Blob([response.data], {type: 'application/pdf'});
                // const url = window.URL.createObjectURL(blob);
                // const link = document.createElement('a');
                // link.href = url;
                // link.setAttribute('download', 'doc.pdf');
                // document.body.appendChild(link);
                // link.click();
                // link.remove();
                // window.URL.revokeObjectURL(url);

                //// to open in new window
                // //Create a Blob from the PDF Stream
                // const file = new Blob(
                //     [response.data],
                //     {type: 'application/pdf'}
                // );
                // //Build a URL from the file
                // const fileURL = URL.createObjectURL(file);
                // //Open the URL on new Window
                // window.open(fileURL);
            })
            .catch(error => {
                console.log(error);
            }).then(function () {
            updateStateValue(setFilters, 'isLoading', false);
        });
    }

    // get filters data
    useEffect(() => {
        //get Disciplines
        apiClient
            .get('getDisciplines')
            .then(response => {
                const disciplineItems = response.data.disciplines.map(
                    ({id, name}) => ({id: id, name: name})
                );
                setDisciplines(disciplineItems);
            });
    }, [updateReportFilters, setValue]);

    return (
        <form
            className="needs-validation container-fluid"
            onSubmit={handleSubmit(onSubmit)}
        >
            <div className="form-row row s-gy">
                <FormSelect
                    id="discipline_id"
                    label="Discipline"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    value={filters.discipline_id}
                    onChange={disciplineSelectionHandler}
                    options={disciplines}
                    register={register({required: {value: true, message: "required"}})}
                    errors={errors}
                />
                <FormSearchableSelect
                    id="job_id"
                    label="Job"
                    options={jobs}
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-3"
                    rules={{required: "required"}}
                    control={control}
                    errors={errors}
                    onChange={(value) => jobSelectionHandler(value)}
                />
                <FormInputDate
                    id="start_date"
                    label="Start Date"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    value={filters.start_date}
                    onChange={(e) => {updateReportFilters('start_date', e.target.value)}}
                    register={register({required: {value: true, message: "required"}})}
                    errors={errors}
                />
                <FormInputDate
                    id="end_date"
                    label="End Date"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    value={filters.end_date}
                    onChange={(e) => {updateReportFilters('end_date', e.target.value)}}
                    register={register({required: {value: true, message: "required"}})}
                    errors={errors}
                />
                <FormSubmitButton
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    label="Convert"
                />
            </div>
        </form>
    );
}

export default FieldDailiesToHTMLFilters;
